var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#007CB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5002 11C25.7764 11 26.0002 11.2239 26.0002 11.5V20.5C26.0002 20.7761 25.7764 21 25.5002 21H21.7189L16.3688 26.8379C16.2355 26.9833 16.0292 27.0367 15.8421 26.9743C14.6597 26.5802 14.0002 25.9207 14.0002 25C14.0002 24.3528 14.4347 23.4539 15.303 22.2458L15.4824 22H13.4248C13.092 22 12.7609 21.9514 12.4421 21.8558C10.6329 21.313 9.60629 19.4064 10.149 17.5973L11.3799 13.4943C11.8241 12.0138 13.1867 11 14.7323 11H25.5002ZM21.0002 12H14.7323C13.6283 12 12.655 12.7242 12.3378 13.7816L11.1069 17.8846C10.7228 19.1648 11.4493 20.5139 12.7294 20.8979C12.955 20.9656 13.1893 21 13.4248 21H16.5002C16.9195 21 17.1526 21.485 16.8907 21.8123L16.5314 22.2708C15.5104 23.6027 15.0002 24.5412 15.0002 25C15.0002 25.3581 15.2567 25.6619 15.859 25.9141L21.0002 20.3055V12ZM25.0002 12H22.0002V20H25.0002V12Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.dcd190eaca10fceb03ac2c2328d9b470.svg";
export { ForwardRef as ReactComponent };